import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { seasonsOperations } from '../../redux/ducks/seasons';

const withSeasons = (WrappedComponent, showLoadingSpinner = true) => {
    const Wrapper = (props) => {
        const seasons = useSelector(({ seasons }) => seasons.seasonsState.seasons);
        const dispatch = useDispatch();

        useEffect(() => {
            if (seasons.length === 0) {
                dispatch(seasonsOperations.fetchSeasons());
            }
        }, []);

        if(Object.keys(seasons).length > 0) {
            return <WrappedComponent {...props} />;
        }
        return <div className="dummy-container"><LoadingDisplay isLoading={showLoadingSpinner}/></div>;
    };

    return Wrapper;
};

export default withSeasons;